import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';

export default PopupHeader;

function PopupHeader(props) {
  const { iconName } = props;
  return (
    <div>
      {iconName && <i className={`${iconName} mr-5`} />}
      <Translate value={props.title} />
    </div>
  );
}

PopupHeader.propTypes = {
  title: PropTypes.string,
  iconName: PropTypes.string,
};

PopupHeader.defaultProps = {
  title: '',
  iconName: '',
};
